import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CommercialModule } from "@/components/site/CommercialModule";

const scrollToDetail = (e) => {
  e.preventDefault();
  document.getElementById("guide-detail")?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const ShortestPath = ({ a }) => (
  <section
    data-testid="shortest-path"
    className="mt-10 border border-line grid md:grid-cols-[1.15fr_1fr] gap-px bg-line"
  >
    <div className="bg-[#F4F2ED] border-t-[3px] border-sage px-7 md:px-9 py-8 md:py-9 flex flex-col">
      <span className="text-[11.5px] tracking-[0.18em] uppercase text-[#48563F] font-semibold">
        Explore your options
      </span>
      <h3 className="display text-[23px] md:text-[26px] leading-[1.25] text-charcoal mt-3.5">
        {a.shop_prompt || "Already know what you need?"}
      </h3>
      <div className="mt-auto pt-6">
        <CommercialModule
          compact
          size="lg"
          category={a.primary_offer_category}
          fallback={a.alternate_offer_category}
          label={a.shop_cta_label || "Explore Options"}
          placement="EARLY CTA"
          articleSlug={a.slug}
          anchorTo={a.offer_showcase ? "#explore-options" : null}
        />
      </div>
    </div>

    <div className="bg-white px-7 md:px-8 py-8 md:py-9 flex flex-col">
      <span className="text-[11.5px] tracking-[0.18em] uppercase text-[#4F4B45] font-semibold">
        Need help deciding?
      </span>
      <h3 className="text-[17.5px] md:text-[19px] font-medium text-charcoal leading-snug mt-3.5">
        {a.help_prompt || "Not sure yet?"}
      </h3>
      <div className="mt-auto pt-6">
        {a.tool ? (
          <Link
            to={`/tools/${a.tool.slug}`}
            data-testid="shortest-path-tool"
            className="inline-flex items-center gap-2 px-7 py-3.5 border border-charcoal/25 text-charcoal text-[12.5px] tracking-[0.14em] uppercase hover:border-sage hover:text-sage transition-colors duration-300"
          >
            {a.help_cta_label || "Open the tool"} <ArrowRight size={15} />
          </Link>
        ) : (
          <a
            href="#guide-detail"
            onClick={scrollToDetail}
            data-testid="shortest-path-detail"
            className="inline-flex items-center gap-2 px-7 py-3.5 border border-charcoal/25 text-charcoal text-[12.5px] tracking-[0.14em] uppercase hover:border-sage hover:text-sage transition-colors duration-300"
          >
            {a.help_cta_label || "Read the detail"} <ArrowRight size={15} />
          </a>
        )}
      </div>
    </div>
  </section>
);

export const SidebarProductCard = ({ a }) => {
  if (!a.primary_offer_category) return null;
  const family = a.product_family || "Options";
  return (
    <div
      data-testid="sidebar-product-card"
      className="hidden lg:block mb-8 bg-[#F4F2ED] border-t-[3px] border-sage px-6 py-7"
    >
      <span className="text-[11px] tracking-[0.16em] uppercase text-[#48563F] font-semibold">
        Explore {family}
      </span>
      <p className="text-[16px] md:text-[17px] leading-[1.6] text-[#454545] mt-3">
        See the {family.toLowerCase()} available when you're ready.
      </p>
      <div className="mt-5">
        <CommercialModule
          compact
          category={a.primary_offer_category}
          fallback={a.alternate_offer_category}
          label="View Options"
          placement="SIDEBAR CTA"
          articleSlug={a.slug}
          anchorTo={a.offer_showcase ? "#explore-options" : null}
        />
      </div>
    </div>
  );
};
